import React, { Component } from "react";
import { Form } from "antd";
import FormCreate from "../../../../../components/FormCreate/index";
import styles from "./EditGroup.less";

const { FormTitle, FormTextArea } = FormCreate;

@Form.create()
class EditGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      number: "",
      name: ""
    };
  }

  componentDidMount() {
    const { name, number } = this.props;
    this.setState({
      name,
      number
    });
  }

  render() {
    const { form, onEdit } = this.props;
    const { number, name } = this.state;
    const normNumberProps = {
      form,
      value: number,
      label: "指标编号",
      keyName: "number",
      maxLength: 10,
      suffix: `${(number && number.length) || 0}/10`,
      onChange: e =>
        this.setState({ number: e.target.value }, () => {
          const { number:newNumber } = this.state
          if (typeof onEdit === "function") {
            onEdit(newNumber, name, form);
          }
        })
    };

    const normNameProps = {
      form,
      value: name,
      label: "指标名称",
      keyName: "name",
      maxLength: 100,
      rows: 5,
      isRequired: true,
      suffix: `${(name && name.length) || 0}/100`,
      onChange: e =>
        this.setState({ name: e.target.value }, () => {
          const { name:newName } = this.state
          if (typeof onEdit === "function") {
            onEdit(number, newName, form);
          }
        })
    };

    return (
      <div className={styles.normGroup}>
        {/* <div className='detail-title'>
          指标情况
        </div> */}
        <div>
          <FormCreate labelCol={{ span: 2 }} wrapperCol={{ span: 21 }}>
            <FormTitle {...normNumberProps} />
            <FormTextArea {...normNameProps} />
          </FormCreate>
        </div>
      </div>
    );
  }
}

export default EditGroup;
